import { getLoyaltyBenefits as getPriorityStatus } from "../../../../services/loyalty";
import { RECEIVE_IS_PRIORITY, LOYALTY_SDK_FAILURE } from "../constants";
import { SdkError } from "../../../../services/errors";

export const getLoyaltyBenefits = () => async dispatch => {
  let isPriority;
  try {
    isPriority = await getPriorityStatus();
  } catch (e) {
    if (e instanceof SdkError) {
      return dispatch({ type: LOYALTY_SDK_FAILURE });
    }
    throw e;
  }
  dispatch({ type: RECEIVE_IS_PRIORITY, payload: { isPriority } });
};
